<template>
  <b-row v-if="campaign" class="campaign-card-header pb-3 border-bottom">
    <b-col class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center">
      <div class="d-flex flex-row align-items-start">
        <b-img v-if="campaign.branding && campaign.branding.colour" blank :blank-color="campaign.branding.colour"
          class="mt-2" height="18px" width="18px" rounded/>
        <div class="d-flex flex-column align-items-start ml-2">
          <span class="campaign-title">{{ campaign.title }}</span>
          <span v-if="campaign.tagline">{{ campaign.tagline }}</span>
        </div>
      </div>
      <div v-if="campaign.startDate || campaign.endDate" class="d-flex align-items-center justify-content-center">
        <span class="text-muted" v-if="campaign.startDate">
          {{ $t('campaign.start-date') }}:<br/>
          <template v-if="campaign.startDate">{{ campaign.startDate | formatDate(`${ $t('dateFormats.short') }`) }}</template>
          <template v-else>-</template>
        </span>
        <span class="px-3" v-if="campaign.startDate && campaign.endDate">—</span>
        <span class="font-weight-bold" v-if="campaign.endDate">
          {{ $t('campaign.end-date') }}:<br/>
          <template v-if="campaign.endDate">{{ campaign.endDate | formatDate(`${ $t('dateFormats.short') }`) }}</template>
          <template v-else>-</template>
        </span>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    campaign: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.campaign-card-header {
  .campaign-title {
    font-size: 20px;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/campaign-dashboard/campaign-card-header.vue